<template>
  <div class="card">
    <div class="card-header">
      <div class="bolder-title">Тональность</div>
      <!--      <date-picker v-model="date"-->
      <!--                   locale="ru"-->
      <!--                   :clearable="false"-->
      <!--                   format="dd.MM.yyyy"-->
      <!--                   model-type="yyyy-MM-dd"-->
      <!--                   auto-apply-->
      <!--                   :enable-time-picker="false"></date-picker>-->
      <br>
      <span class="help-text"> Для расчёта изменений используется сравнение с предыдущим периодом {{$compare_period(date_from, date_to)}}</span>

    </div>
    <div class="card-body">
      <div class="point">
        <div class="title">Всего отзывов
        <popper hover content="Количество собранных отзывов за весь периода сбора. Здесь считаются именно собранные нашим сервисом отзывы">
    <i class="bi bi-info pointer"></i>
  </popper>
        </div>
        <div class="values" v-if="stats.reviews">
          <div class="value">{{ formatNumber(stats.reviews.total) }}</div>
          <div :class="`diff ${stats.reviews.change_direction==='up'?'red':'green'}`">
            <template v-if="stats.reviews.change_direction==='up'">+</template>
            {{ stats.reviews.change_percent <= 100 ? stats.reviews.change_percent : 100 }}%
          </div>
        </div>

      </div>
      <div class="point">
        <div class="title"><i class="badge green"></i> Позитивные</div>
        <div class="values" v-if="stats.positives">
          <div class="value">{{ formatNumber(stats.positives.total) }}</div>
          <div :class="`diff ${stats.positives.change_direction==='up'?'green':'red'}`">
            <template v-if="stats.positives.change_direction==='up'">+</template>
            {{ stats.positives.change_percent <= 100 ? stats.positives.change_percent : 100 }}%
          </div>
        </div>
      </div>
      <div class="point">
        <div class="title"><i class="badge red"></i> Негативные</div>
        <div class="values" v-if="stats.negatives">
          <div class="value">{{ formatNumber(stats.negatives.total) }}</div>
          <div :class="`diff ${stats.negatives.change_direction==='up'?'red':'green'}`">
            <template v-if="stats.negatives.change_direction==='up'">+</template>
            {{ stats.negatives.change_percent <= 100 ? stats.negatives.change_percent : 100 }}%
          </div>
        </div>
      </div>

    </div>
  </div>

</template>

<script>
import {ReviewApi} from "@/api/reviews";
import datesMixin from "@/mixins/filterDates";

export default {
  name: 'ToneStat',
  data() {
    return {
      stats: {}
    }
  },
  mixins: [datesMixin],

  mounted: function () {
    this.getData();

  },
  methods: {
    getData() {
      ReviewApi.tone_stat(this.date_from, this.date_to).then(response => this.stats = response)
    },
    formatNumber(num) {
      if (num >= 1000) {
        return Math.floor((num / 1000) * 10) / 10 + 'K';
      }
      return num.toString();
    }
  }
}

</script>
<style scoped lang="scss">
.card-body {
  display: flex;
  justify-content: space-between;
  gap: 20px;

  .point {

    width: 100%;

    &:not(:last-child) {
      border-right: 1px solid #ccc;
    }

    .badge {
      height: 16px;
      width: 16px;

    }

    .title {
      padding-bottom: 5px;
      display: flex;
      align-items: center;
      gap: 5px;

      .badge {
        height: 16px;
        width: 16px;
        border-radius: 16px;
        display: inline-block;

        &.green {
          background: rgba(52, 145, 126, 1);
        }

        &.red {
          background: rgba(209, 0, 47, 1);
        }

      }
    }

    .values {
      display: flex;
      gap: 4px;
      align-items: end;

      .value {
        color: rgba(0, 143, 248, 1);
        font-size: 24px;
        font-weight: 700;
        line-height: 24px;
      }

      .diff {
        font-size: 12px;
        line-height: 16px;

        &.green {
          color: rgba(0, 124, 101, 1)
        }

        &.red {
          color: rgba(209, 0, 47, 1);
        }
      }
    }

  }
}

@media (width < 768px) {
  .card-body {
    .point {

      .title {
        font-size: 12px;
        white-space: nowrap;
        padding-right: 3px;
      }
    }
  }
}


</style>

